import { defineComponent as h, useId as k, createElementBlock as v, createCommentVNode as $, openBlock as a, Fragment as C, renderList as V, normalizeClass as B, createElementVNode as S, createBlock as p, unref as s, toDisplayString as j } from "vue";
import E from "./ServerVariablesSelect.vue.js";
import F from "./ServerVariablesTextbox.vue.js";
const N = ["for"], z = /* @__PURE__ */ h({
  __name: "ServerVariablesForm",
  props: {
    variables: {},
    values: {},
    controls: {},
    layout: { default: "client" }
  },
  emits: ["update:variable"],
  setup(i, { emit: g }) {
    const y = g, n = k();
    function u(r, l) {
      y("update:variable", r, l);
    }
    const c = (r) => {
      var l, e, t;
      return (((l = i.values) == null ? void 0 : l[r]) ?? ((t = (e = i.variables) == null ? void 0 : e[r]) == null ? void 0 : t.default) ?? "").toString();
    };
    return (r, l) => r.variables && Object.keys(r.variables ?? {}).length ? (a(!0), v(C, { key: 0 }, V(Object.keys(r.variables), (e) => {
      var t, b, d, f, m;
      return a(), v("div", {
        key: e,
        class: B([
          "group/label flex w-full",
          r.layout === "reference" && "items-center border-x border-b last:rounded-b-lg"
        ])
      }, [
        S("label", {
          for: `${s(n)}-${e}`,
          class: "flex items-center py-1.5 pl-3 group-has-[input]/label:mr-0 after:content-[':']"
        }, j(e), 9, N),
        (d = (b = (t = r.variables) == null ? void 0 : t[e]) == null ? void 0 : b.enum) != null && d.length ? (a(), p(E, {
          key: 0,
          id: `${s(n)}-${e}`,
          controls: r.controls,
          enum: ((m = (f = r.variables[e]) == null ? void 0 : f.enum) == null ? void 0 : m.map((o) => `${o}`)) ?? [],
          value: c(e),
          onChange: (o) => u(e, o)
        }, null, 8, ["id", "controls", "enum", "value", "onChange"])) : (a(), p(F, {
          key: 1,
          id: `${s(n)}-${e}`,
          controls: r.controls,
          value: c(e),
          onChange: (o) => u(e, o)
        }, null, 8, ["id", "controls", "value", "onChange"]))
      ], 2);
    }), 128)) : $("", !0);
  }
});
export {
  z as default
};
